import FasesSection from '../../sections/FasesSection';
import Gallery from '../../sections/Gallery';
import Descargas from '../../components/Descargas';
import Hero from '../../components/Hero';
import ModernBanner from '../../components/ModernBanner';

import { motion,AnimatePresence } from "framer-motion";
import { FaFilePdf, FaProjectDiagram, FaLightbulb, FaClipboardList, FaMap } from "react-icons/fa";

import './Cacs.css';
import React, { useState, useMemo } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { 
  Home as HomeIcon,
  MapPin as MapPinIcon,
  FileText as FileTextIcon,
  Phone as PhoneIcon,
  ChevronDown,
  ChevronRight,
  Menu,
  X,
  ExternalLink,
  Subtitles,
  Users,
  Map,
  Landmark,
  Calendar,
  Info,
  MountainSnow,
  TreePine,
  TreePineIcon,
  MapPin, Book,BookOpen, FileSearch, Layers, Target, FileCheck, Search, Award, Zap, BarChart3,
  Download, Loader2, FileSearch as FileSearchIcon,FileText,Paperclip,FileSignature,FileSpreadsheet,LayersIcon,GlobeIcon,CheckCircle
} from 'lucide-react';
import { a } from 'framer-motion/client';
import { DocumentRepository2 } from '../../components/DocumentRepository';

const FullWidthVisorWithSidebar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeTab, setActiveTab] = useState('uga');

  return (
    <section id="visor-completo" className="py-16">
      <div className="max-w-[2000px] mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
              Plataforma Geoespacial Completa
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
            Sistema de información geográfica integrado con documentación técnica completa
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          {/* Sidebar - Ancho fijo */}
          <motion.div
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            className={`lg:w-96 ${sidebarOpen ? 'block' : 'hidden lg:block'}`}
          >
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-xl border border-gray-100 dark:border-gray-700 sticky top-6">
              {/* Botón toggle para móviles */}
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="lg:hidden mb-4 w-full p-2 bg-gradient-to-r from-blue-500 to-teal-500 
                  text-white rounded-lg flex items-center justify-center gap-2"
              >
                {sidebarOpen ? 'Ocultar Panel' : 'Mostrar Panel'}
                <ChevronRight className={`w-4 h-4 transition-transform ${sidebarOpen ? 'rotate-90' : ''}`} />
              </button>

              {/* Tabs de navegación */}
              <div className="flex mb-6 bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
                <button
                  onClick={() => setActiveTab('uga')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'uga'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Clasificación UGA
                </button>
                <button
                  onClick={() => setActiveTab('descripcion')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'descripcion'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Descripción UGA
                </button>
                <button
                  onClick={() => setActiveTab('politica')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'politica'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Política Ambiental
                </button>
              </div>

              {/* Contenido según tab activo */}
              <AnimatePresence mode="wait">
                <motion.div
                  key={activeTab}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="space-y-6"
                >
                  {activeTab === 'uga' && (
                    <>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                          <LayersIcon className="w-5 h-5 text-blue-500 mr-2" />
                          Clasificación de UGAs
                        </h3>
                        <img
                          src="/images/Clave_UGA_Cuenca_Alta_de_la_Costa_Sur.png"
                          alt="Clasificación de Unidades de Gestión Ambiental"
                          className="w-full h-auto rounded-lg shadow-md mb-4"
                        />
                        <p className="text-sm text-gray-600 dark:text-gray-300">
                          Mapa de clasificación de las Unidades de Gestión Ambiental (UGAs) 
                          de la región Cuenca Alta de la Costa Sur.
                        </p>
                      </div>
                    </>
                  )}

                  {activeTab === 'descripcion' && (
                    <>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                          <Info className="w-5 h-5 text-teal-500 mr-2" />
                          Descripción de las UGAs
                        </h3>
                        <p className="text-gray-600 dark:text-gray-300 mb-4">
                          Las <strong>Unidades de Gestión Ambiental (UGAs)</strong> son la unidad mínima 
                          del territorio a la que se asignan determinados lineamientos y estrategias 
                          ecológicas para su manejo específico.
                        </p>
                        
                        <div className="space-y-4">
                          <div className="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 
                            rounded-lg p-4">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-2">Características</h4>
                            <ul className="text-sm text-gray-600 dark:text-gray-300 space-y-1">
                              <li>• Unidad territorial homogénea</li>
                              <li>• Criterios específicos de manejo</li>
                              <li>• Estrategias ecológicas definidas</li>
                              <li>• Monitoreo individualizado</li>
                            </ul>
                          </div>
                          
                          <div className="bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 
                            rounded-lg p-4">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-2">Objetivos</h4>
                            <ul className="text-sm text-gray-600 dark:text-gray-300 space-y-1">
                              <li>• Gestión ambiental específica</li>
                              <li>• Aplicación de lineamientos</li>
                              <li>• Evaluación de resultados</li>
                              <li>• Adaptación de estrategias</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {activeTab === 'politica' && (
                    <>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                          <Target className="w-5 h-5 text-purple-500 mr-2" />
                          Política Ambiental
                        </h3>
                        <p className="text-gray-600 dark:text-gray-300 mb-4">
                          El presente <strong>Modelo de Ordenamiento Ecológico y Territorial Regional</strong> considera una zonificación, integrada por cinco políticas que buscan definir el estado deseable del territorio mediante lineamientos, estrategias y criterios para conservar y controlar el deterioro del ambiente así como el aprovechamiento sustentable de los recursos naturales.
                        </p>
                        
                        {/* <div className="space-y-3 text-sm text-gray-600 dark:text-gray-300">
                          <div className="border-l-4 border-blue-500 pl-3">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-1">1. Conservación Ecológica Integral (CEI)</h4>
                            <p>Áreas con alta prioridad para la conservación de la biodiversidad y ecosistemas naturales.</p>
                          </div>
                          
                          <div className="border-l-4 border-green-500 pl-3">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-1">2. Conservación Ecológica (CE)</h4>
                            <p>Áreas que requieren medidas de conservación manteniendo sus funciones ecológicas.</p>
                          </div>
                          
                          <div className="border-l-4 border-orange-500 pl-3">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-1">3. Aprovechamiento Sustentable</h4>
                            <p>Uso racional de recursos naturales con estándares ambientales.</p>
                          </div>
                          
                          <div className="border-l-4 border-red-500 pl-3">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-1">4. Restauración</h4>
                            <p>Recuperación de áreas degradadas y ecosistemas deteriorados.</p>
                          </div>
                          
                          <div className="border-l-4 border-indigo-500 pl-3">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-1">5. Desarrollo Urbano</h4>
                            <p>Crecimiento ordenado respetando criterios ambientales.</p>
                          </div>
                        </div> */}
                      </div>
                    </>
                  )}
                </motion.div>
              </AnimatePresence>

              {/* Botones de acción */}
              <div className="mt-8 pt-6 border-t border-gray-100 dark:border-gray-700">
                <div className="grid grid-cols-2 gap-3">
                  <a
                    href="https://siga.jalisco.gob.mx/ordenamiento/visores/visorcacs/index.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2.5 bg-gradient-to-r from-blue-500 to-teal-500 text-white 
                      rounded-lg text-sm font-medium text-center hover:shadow-lg transition-all"
                  >
                    <ExternalLink className="w-4 h-4 inline mr-1" />
                    Abrir en Nueva Ventana
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Visor - Ocupa el resto del espacio */}
          <div className="flex-1">
            <div className="bg-gray-900 rounded-2xl overflow-hidden shadow-2xl">
              <div className="p-4 bg-gradient-to-r from-gray-800 to-gray-900 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-r from-blue-500 to-teal-500 rounded-lg">
                    <GlobeIcon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white">Visor GIS CACS</h3>
                    <p className="text-sm text-gray-400">Sistema interactivo de información geográfica</p>
                  </div>
                </div>
              </div>
              
              <div className="h-[600px]">
                <iframe
                  src="https://siga.jalisco.gob.mx/ordenamiento/visores/visorcacs/index.html"
                  className="w-full h-full border-0"
                  title="Visor GIS CACS"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const ModernBitacoraSection = ({ items }) => {
  const [expandedSection, setExpandedSection] = useState(0);

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white dark:from-gray-900 dark:to-gray-800">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
              Bitácora del Programa
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Registro documental completo del proceso de ordenamiento ecológico
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {items.map((item, index) => {
            const Icon = item.icon;
            return (
              <motion.button
                key={index}
                onClick={() => setExpandedSection(expandedSection === index ? null : index)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`p-6 rounded-2xl transition-all duration-300 text-left ${
                  expandedSection === index
                    ? `bg-gradient-to-br ${item.color} text-white shadow-2xl`
                    : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 shadow-lg hover:shadow-xl'
                }`}
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className={`p-3 rounded-xl ${
                    expandedSection === index
                      ? 'bg-white/20'
                      : `bg-gradient-to-br ${item.color}`
                  }`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="text-lg font-semibold">{item.title}</h3>
                </div>
                <p className={`text-sm ${
                  expandedSection === index ? 'text-white/90' : 'text-gray-500 dark:text-gray-400'
                }`}>
                  {expandedSection === index ? 'Ver documentos ↓' : 'Ver documentos →'}
                </p>
              </motion.button>
            );
          })}
        </div>

        {/* Contenido expandido */}
        <AnimatePresence>
          {expandedSection !== null && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
              className="overflow-hidden"
            >
              <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-xl border border-gray-100 dark:border-gray-700">
                {items[expandedSection].content.map((section, sectionIndex) => (
                  <div key={sectionIndex} className="mb-8 last:mb-0">
                    <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-6 flex items-center">
                      <div className="w-3 h-3 bg-gradient-to-r from-blue-500 to-teal-500 rounded-full mr-3" />
                      {section.subtitle}
                    </h4>
                    <div className="grid md:grid-cols-2 gap-4">
                      {section.items.map((doc, docIndex) => (
                        <a
                          key={docIndex}
                          href={doc.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="group p-4 bg-gray-50 dark:bg-gray-700 rounded-xl hover:bg-gradient-to-r hover:from-blue-50 hover:to-teal-50 
                            dark:hover:from-blue-900/20 dark:hover:to-teal-900/20 transition-all duration-300"
                        >
                          <div className="flex items-center gap-3">
                            <FileText className="w-5 h-5 text-blue-500 group-hover:text-teal-500 transition-colors" />
                            <span className="text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-white">
                              {doc.text}
                            </span>
                          </div>
                        </a>
                      ))}
                    </div>
                  </div>
                ))}
                
                <div className="mt-8 pt-6 border-t border-gray-100 dark:border-gray-700">
                  <p className="text-sm text-gray-500 dark:text-gray-400 text-center">
                    {items[expandedSection].content.reduce((total, section) => total + section.items.length, 0)} documentos disponibles
                  </p>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};



const DocumentRepository = ({ 
  mainDocs = [], 
  annexDocs = [], 
  title = "Repositorio", 
  subtitle = "Documentación", 
  accentColor = "emerald" 
}) => {
  const [activeTab, setActiveTab] = useState('main');
  const [searchQuery, setSearchQuery] = useState('');
  const [downloadingId, setDownloadingId] = useState(null);

  // Mapeo dinámico de colores de Tailwind
  const colorMap = {
    emerald: { text: 'text-emerald-400', border: 'border-emerald-500', bg: 'bg-emerald-500', glow: 'shadow-emerald-500/20' },
    blue: { text: 'text-blue-400', border: 'border-blue-500', bg: 'bg-blue-500', glow: 'shadow-blue-500/20' },
    rose: { text: 'text-rose-400', border: 'border-rose-500', bg: 'bg-rose-500', glow: 'shadow-rose-500/20' }
  };

  const currentTheme = colorMap[accentColor] || colorMap.emerald;

  const filteredDocs = useMemo(() => {
    const list = activeTab === 'main' ? mainDocs : annexDocs;
    return list.filter(doc => 
      doc.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (doc.subtitle && doc.subtitle.toLowerCase().includes(searchQuery.toLowerCase()))
    );
  }, [searchQuery, activeTab, mainDocs, annexDocs]);

  const handleDownload = (doc) => {
    if (!doc.url) {
      console.error("No URL provided for this document");
      return;
    }
    
    setDownloadingId(doc.id);
    
    // Simulación de delay de preparación y ejecución de descarga real
    setTimeout(() => {
      const link = document.createElement('a');
      link.href = doc.url;
      link.setAttribute('download', doc.filename || doc.title);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setDownloadingId(null);
    }, 1200);
  };

  const TabButton = ({ id, label, icon: Icon }) => (
    <button
      onClick={() => { setActiveTab(id); setSearchQuery(''); }}
      className={`flex-1 flex items-center justify-center space-x-2 py-4 text-xs font-bold transition-all relative z-10 ${
        activeTab === id ? 'text-white' : 'text-slate-500 hover:text-slate-300'
      }`}
    >
      <Icon className="w-4 h-4" />
      <span className="uppercase tracking-[0.2em]">{label}</span>
      {activeTab === id && (
        <motion.div
          layoutId="activeTabBg"
          className={`absolute inset-0 bg-gradient-to-r from-slate-800 to-transparent border-b-2 ${currentTheme.border} z-[-1]`}
        />
      )}
    </button>
  );

  return (
    <div className="max-w-3xl mx-auto w-full">
      {/* Card de Cabecera */}
      <div className="bg-slate-900/40 rounded-3xl border border-slate-800/50 p-6 md:p-8 mb-6 backdrop-blur-xl shadow-2xl relative overflow-hidden">
        <div className="flex items-center justify-between mb-8 relative z-10">
          <div className="flex items-center space-x-4">
            <div className={`h-14 w-14 rounded-2xl bg-gradient-to-tr from-slate-800 to-slate-700 flex items-center justify-center shadow-lg ${currentTheme.glow}`}>
              <FileText className={`w-7 h-7 ${currentTheme.text}`} />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-black text-white tracking-tighter italic">{title}</h1>
              <p className={`text-[10px] md:text-xs ${currentTheme.text} font-bold uppercase tracking-[0.4em]`}>{subtitle}</p>
            </div>
          </div>
        </div>

        {/* Buscador */}
        <div className="relative group">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-500 group-focus-within:text-white transition-colors" />
          <input 
            type="text"
            placeholder="Buscar en este repositorio..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full bg-black/40 border border-slate-800 rounded-2xl py-4 pl-12 pr-4 text-base focus:outline-none focus:ring-1 focus:ring-slate-700 transition-all placeholder:text-slate-600 shadow-inner text-white"
          />
        </div>
      </div>

      {/* Tabs */}
      <div className="flex bg-slate-900/20 rounded-t-2xl border-x border-t border-slate-800/50 overflow-hidden backdrop-blur-md">
        <TabButton id="main" label="Documentos" icon={Layers} />
        <TabButton id="annex" label="Anexos" icon={Paperclip} />
      </div>

      {/* Lista */}
      <div className="bg-slate-900/20 border-x border-b border-slate-800/50 rounded-b-3xl p-3 min-h-[400px] backdrop-blur-md shadow-xl">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab + searchQuery}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -15 }}
            transition={{ duration: 0.3 }}
            className="space-y-2"
          >
            {filteredDocs.length > 0 ? (
              filteredDocs.map((doc) => (
                <div key={doc.id} className="group relative flex items-center bg-slate-900/40 hover:bg-slate-800/70 border border-slate-800/40 rounded-2xl p-4 transition-all">
                  <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-black/60 flex items-center justify-center mr-4">
                    {doc.icon || <FileText className="w-5 h-5 text-slate-500" />}
                  </div>
                  <div className="flex-grow min-w-0 pr-4">
                    <h3 className="text-base font-bold text-slate-100 truncate group-hover:text-white">{doc.title}</h3>
                    <p className="text-xs text-slate-500 truncate italic">{doc.subtitle || "Archivo disponible para descarga."}</p>
                  </div>
                  <button 
                    onClick={() => handleDownload(doc)}
                    disabled={downloadingId === doc.id}
                    className={`flex-shrink-0 flex items-center space-x-2 px-4 py-2.5 rounded-xl font-bold text-xs transition-all ${
                      downloadingId === doc.id ? 'bg-white/10 text-white' : `bg-white/5 text-slate-400 hover:text-white hover:${currentTheme.bg}`
                    }`}
                  >
                    {downloadingId === doc.id ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
                  </button>
                </div>
              ))
            ) : (
              <div className="py-24 text-center">
                <FileSearch className="w-10 h-10 text-slate-800 mx-auto mb-4" />
                <p className="text-slate-500 text-sm">No se encontraron resultados</p>
              </div>
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

const DetailBadge = ({ icon: Icon, label, value }) => (
  <div className="flex items-center p-3 bg-gray-50 dark:bg-gray-700 rounded-xl transition-all hover:bg-teal-100 dark:hover:bg-teal-900/30">
    <Icon className="text-teal-600 dark:text-teal-400 mr-3 flex-shrink-0" size={20} />
    <div className="text-sm">
      <span className="font-semibold text-gray-700 dark:text-gray-300 block leading-tight">{label}:</span>
      <span className="text-gray-900 dark:text-white font-bold">{value}</span>
    </div>
  </div>
);

const Items = [
  {
    title: "Archivos Vectoriales",
    description: "Archivos geoespaciales para la consulta SIG.",
    imageUrl: "images/vectoriales.png", // sky-600
    baseColor: "sky",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/VectorialesCacs.zip",
    target: "_blank",
  },
  {
    title: "Fichas UGAss",
    description: "Informacion detallada de cada Unidad de Gestión Ambiental (UGA).",
    imageUrl: "images/FICHAS_UGA.png", // green-600
    baseColor: "green",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/Fichas%20de%20las%20Unidades%20de%20Gesti%C3%B3n%20Ambiental%20Regi%C3%B3n%20Cuenca%20Alta%20de%20la%20Costa%20Sur.pdf",
    target: "_blank",
  },
  {
    title: "Criterios",
    description: "Regulaciones ecológicas para la preservación y restauración del territorio.",
    imageUrl: "images/Criterios.png", // orange-600
    baseColor: "orange",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/Criterios%20de%20regulaci%C3%B3n%20ecol%C3%B3gica%20Regi%C3%B3n%20Cuenca%20Alta%20de%20la%20Costa%20Sur.pdf",
    target: "_blank",
  },
  {
    title: "Estrategias Ecologicas",
    description: "Proyectos de orientación para la protección del entorno natural.",
    imageUrl: "images/Estrategias.png", // red-600
    baseColor: "red",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/Opini%C3%B3n%20estrat%C3%A9gica%20del%20Programa%20de%20Ordenamiento%20Ecol%C3%B3gico%20y%20Territorial.pdf",
    target: "_blank",
  },
  {
    title: "Lineamientos",
    description: "Conservar, proteger y restaurar los recursos naturales de la región.",
    imageUrl: "images/Lineamientos.png", // indigo-600
    baseColor: "indigo",
    
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/Lineamientos%20ecol%C3%B3gicos%20Regi%C3%B3n%20Cuenca%20Alta%20de%20la%20Costa%20Sur.pdf",
    target: "_blank",
  },
  {
    title: "Compatibilidades",
    description: "Guia de compatibilidades de usos de suelo estratégicos",
    imageUrl: "images/Compatibilidades.png", // teal-600
    baseColor: "teal",
    
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/Listado%20de%20usos%20compatibles%20y%20actividades%20compatibles%20Regi%C3%B3n%20Cuenca%20Alta%20de%20la%20Costa%20Sur.pdf",
    target: "_blank",
  },
];

const items = [
  {
    title: "Archivos Vectoriales",
    description: "Formatos editables y mapas en alta calidad.",
     img: <img src="images/vectoriales.png" alt="Archivos Vectoriales" className="w-16 h-16 mb-4" />,
    icon: <FaMap className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/VectorialesCacs.zip",
    target: "_blank",
  },
  {
    title: "Fichas",
    description: "Documentos descriptivos y técnicos.",
    img: <img src="images/Fichas_Informativas.png" alt="Fichas" className="w-16 h-16 mb-4" />,
    icon: <FaClipboardList className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/Fichas%20de%20las%20Unidades%20de%20Gesti%C3%B3n%20Ambiental%20Regi%C3%B3n%20Cuenca%20Alta%20de%20la%20Costa%20Sur.pdf",
    target: "_blank",
  },
  {
    title: "Criterios",
    description: "Lineamientos técnicos y normativos.",
     img: <img src="images/Criterios.png" alt="Criterios" className="w-16 h-16 mb-4" />,
    icon: <FaFilePdf className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/Criterios%20de%20regulaci%C3%B3n%20ecol%C3%B3gica%20Regi%C3%B3n%20Cuenca%20Alta%20de%20la%20Costa%20Sur.pdf",
  },
  {
    title: "Estrategias",
    description: "Propuestas y planes de acción.",
    img: <img src="images/Estrategias.png" alt="Estrategias" className="w-16 h-16 mb-4" />,
    icon: <FaProjectDiagram className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/Opini%C3%B3n%20estrat%C3%A9gica%20del%20Programa%20de%20Ordenamiento%20Ecol%C3%B3gico%20y%20Territorial.pdf",
  },
  {
    title: "Lineamientos",
    description: "Guías de aplicación práctica.",
    img: <img src="images/Lineamientos.png" alt="Lineamientos" className="w-16 h-16 mb-4" />,
    icon: <FaLightbulb className="text-5xl text-white" />,
    link: "hhttps://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/Lineamientos%20ecol%C3%B3gicos%20Regi%C3%B3n%20Cuenca%20Alta%20de%20la%20Costa%20Sur.pdf",
  },
];

const imageList = [
    {
        id: '1',
        src: 'images/Escudo_Amatitán.png',
        thumbnail: 'images/Escudo_Amatitán.png',
        alt: 'Paisaje con montañas',
        caption: 'Amatitán.'
    },
    {
        id: '2',
        src: 'images/tomatlan-escudo.png',
        thumbnail: 'images/tomatlan-escudo.png',
        alt: 'Ciudad nocturna',
        caption: 'Tomatlán.'
    },
    {
        id: '3',
        src: 'images/la_huerta-escudo.png',
        thumbnail: 'images/la_huerta-escudo.png',
        alt: 'Bosque en otoño',
        caption: 'La Huerta.'
    },
    {
        id: '4',
        src: 'images/cihuatlan-escudo.png',
        thumbnail: 'images/cihuatlan-escudo.png',
        alt: 'Playa tropical',
        caption: 'Cihuatlán.'
    },
    
];

// Datos de los municipios
const municipalities = [
  {
    id: 1,
    name: 'Casimiro Castillo',
    shield: 'images/Escudo_de_Casimiro_Castillo.png',
    description: 'Dedicado a la agricultura de temporal y riego, ganadería y producción pesquera en arroyos y esteros, se ubica en valles y lomeríos con suelos fértiles y fragmentos de selva tropical. Su territorio favorece el ecoturismo rural, la observación de flora y fauna local.',
    population: '20,548 habitantes',
    area: '522.7  km²',
    foundation: '1943',
    attractions: 'El río Purificación, arroyos permanentes como El Conejo y El Tigre, y la laguna El Capulín ofrecen paisajes naturales y actividades al aire libre. Destacan también los bosques de encino y pino en las sierras, así como petroglifos en zonas arqueológicas del municipio..',
    color: 'from-blue-500 to-teal-600',
    administrativeRegion: 'Región Costa-Sur',
    NumerodeUgas: '10',
    EcologicaZona: 'Área Natural Protegida Reserva de la Biosfera Sierra de Manantlán.',
  },
  {
    id: 2,
    name: 'Cuautitlán de García Barragán',
    shield: 'images/Escudo_de_Cuautitlan_de_Garcia_Barragan.png',
    description: 'Con agricultura de temporal y riego, ganadería y pequeña producción forestal, el municipio se desarrolla en valles y sierras con bosques de pino–encino y ríos intermitentes. Su entorno natural permite el turismo rural',
    population: '18,370 habitantes',
    area: '1,391.1 km²',
    foundation: '1946',
    attractions: 'El río Marabasco y el Cuzalapa, junto con las lagunas Las Cabezadas y La Murillo, ofrecen paisajes naturales destacados. Sus bosques de pino y oyamel en la Sierra de Manantlán son ideales para senderismo y observación de flora y fauna. Además, existen zonas arqueológicas en la región de Cuzalapa.',
    color: 'from-green-500 to-emerald-600',
    administrativeRegion: 'Región Costa-Sur',
    NumerodeUgas: '14',
    EcologicaZona: 'Área Natural Protegida Reserva de la Biosfera Sierra de Manantlán.',
  },
  {
    id: 3,
    name: 'Villa Purificación',
    shield: 'images/Escudo_de_Villa_Purificacion.png',
    description: 'Destacado por la agricultura de riego y temporal, ganadería y actividades pesqueras en ríos y arroyos, se ubica en lomeríos y valles con selvas tropicales y fragmentos de bosque de galería. Su territorio facilita la observación de fauna y flora',
    population: '11,303 habitantes',
    area: '1,848.1 km²',
    foundation: '1871',
    attractions: 'Reserva de la biosfera, playas, manglares',
    color: 'from-amber-500 to-orange-600',
    administrativeRegion: 'Región Costa-Sur',
    NumerodeUgas: '15',
    EcologicaZona: ' ',
  }
 
];


const cacsmain = [
  {id: 0, title: "Publicación en  Periódico Oficial", subtitle: "Versión completa", icon: <Book className="w-5 h-5 text-green-400" />,
    url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/Publicaci%C3%B3n%20del%20Peri%C3%B3dico%20Oficial%20Programa%20de%20Ordenamiento%20Ecol%C3%B3gico%20Regi%C3%B3n%20Cuenca%20Alta%20de%20la%20Costa%20Sur.pdf"
   },
    { id: 1, title: "POETR Sierra CACS", subtitle: "Versión abreviada", icon: <Map className="w-5 h-5 text-emerald-400" />,
    url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/Programa%20de%20Ordenamiento%20Ecol%C3%B3gico%20Regi%C3%B3n%20Cuenca%20Alta%20de%20la%20Costa%20Sur.pdf"
     },
    { id: 2, title: "A. Guía de lectura", subtitle: "Introducción", icon: <BookOpen className="w-5 h-5 text-blue-400" />,
    url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/A.%20Gu%C3%ADa%20de%20lectura%20Introducci%C3%B3n.cleaned%20(1).pdf"
     },
    { id: 3, title: "B. Bases técnicas", subtitle: "Metodología", icon: <FileSearch className="w-5 h-5 text-purple-400" />,
    url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/B.%20Bases%20t%C3%A9cnicas%20(2).pdf"
     },
    { id: 4, title: "C. Estructura POETR", subtitle: "Contenido detallado", icon: <Layers className="w-5 h-5 text-amber-400" />,
    url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/C.%20Programa%20de%20Ordenamiento%20Ecol%C3%B3gico%20Territorial.pdf"
     },
    { id: 5, title: "D. Plan Integración Urbana", subtitle: "Desarrollo Regional", icon: <Target className="w-5 h-5 text-rose-400" />,
    url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/Plan%20Regional%20de%20Integraci%C3%B3n%20Urbana%20Regi%C3%B3n%20Cuenca%20Alta%20de%20la%20Costa%20Sur.pdf"
     },
  ];

  const cacsAnnex = [
    { id: '6.1', title: "Proyectos estratégicos", url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/ANEXO%203.%20Proyectos%20estrat%C3%A9gicos%20(1).pdf" },
    { id: '6.2', title: "Indicadores", url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/ANEXO%208.%20Indicadores.cleaned.pdf" },
    { id: '6.3', title: "Apéndice técnico", url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/ANEXO%203.%20Proyectos%20estrat%C3%A9gicos%20(1).pdf" },
    { id: '6.4', title: "Agenda territorial", url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/ANEXO%207.%20Agenda%20territorial.cleaned.pdf" }
  ];

  const cacsRepositoryDocuments = [
    ...cacsmain.map((doc) => ({ ...doc, category: 'Documentos' })),
    ...cacsAnnex.map((doc) => ({ ...doc, category: 'Anexos' }))
  ];

  const TIMELINE_DATA3 = [
  { 
    id: 1,
    date: 'Nov 2022', 
    event: 'Inicio del Proceso', 
    status: 'completed',
    description: 'Firma del convenio y conformación del equipo técnico',
    icon: FileCheck,
    duration: '3 meses',
    participants: 15,
    documents: ['POET-IN-001', 'POET-IN-002']
  },
  { 
    id: 2,
    date: 'Feb 2023', 
    event: 'Diagnóstico Integral', 
    status: 'completed',
    description: 'Estudios técnicos ambientales y consultas públicas regionales',
    icon: Search,
    duration: '9 meses',
    participants: 45,
    documents: ['POET-DI-001', 'POET-DI-002', 'POET-DI-003'],
    milestones: ['Estudio hidrológico', 'Análisis de suelo', 'Consulta ciudadana']
  },
  { 
    id: 3,
    date: 'Oct 2023', 
    event: 'Propuesta Técnica', 
    description: 'Elaboración del documento base y validación técnica',
    icon: BookOpen,
    duration: '8 meses',
    participants: 28,
    documents: ['POET-PT-001', 'POET-PT-002'],
    milestones: ['Modelo predictivo', 'Propuesta de zonificación', 'Revisión por pares']
  },
  { 
    id: 4,
    date: 'Nov 2024', 
    event: 'Publicación Oficial', 
    status: 'completed',
    description: 'Revisión legal y publicación en Periódico Oficial',
    icon: Award,
    duration: '1 mes',
    participants: 32,
    documents: ['POET-AP-001', 'POET-AP-002', 'POET-AP-003'],
    milestones: ['Dictamen legal', 'Publicación oficial', 'Presentación pública'],
    highlight: true
  },
  { 
    id: 5,
    date: 'Actual', 
    event: 'Implementación Activa', 
    status: 'current',
    description: 'Ejecución de proyectos piloto y seguimiento continuo',
    icon: Zap,
    duration: 'En curso',
    participants: 62,
    documents: ['POET-IM-001', 'POET-IM-002', 'POET-IM-003', 'POET-IM-004'],
    milestones: ['Proyecto piloto A', 'Sistema de monitoreo', 'Capacitaciones'],
    progress: 65,
    active: true
  },
  { 
    id: 6,
    date: '2026', 
    event: 'Primera Evaluación', 
    status: 'pending',
    description: 'Revisión de resultados, impactos y ajustes del programa',
    icon: BarChart3,
    duration: '6 meses (plan)',
    participants: 24,
    documents: [],
    milestones: ['Evaluación de impacto', 'Informe de resultados', 'Ajustes al programa']
  }
];

const CacsPage = () => {
  const [selectedMunicipality, setSelectedMunicipality] = useState(municipalities[0]);
  const handleScroll = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const aboutContent = `

  <h2 class="text-2xl font-bold mb-4">Ordenamiento Ecológico Regional Cuenca Alta de la Costa Sur</h2>

    <p class="justify">El Gobierno del Estado de Jalisco impulsa el desarrollo sustentable en la región denominada Cuenca Alta de la Costa Sur, integrada por los municipios de Casimiro Castillo, Cuautitlán de García Barragán y Villa Purificación. Para impulsar dicho desarrollo, el día 17 de octubre del 2022 el Gobierno del Estado de Jalisco y los municipios firmaron un Convenio de Coordinación que garantiza la realización de las actividades programadas. Se trata de una colaboración que involucra por igual a los diferentes órdenes de gobierno: Estado y Municipios. El objeto del convenio consistió en establecer las bases para el proceso destinado a la elaboración del ordenamiento territorial.</p>
<p> Asimismo, se firmó con la Federación un Convenio Marco de Coordinación junto con SEMARNAT Y SEDATU de fecha el 27 de enero de 2020.  Estos convenios establecen los fundamentos para la colaboración en el proceso de elaboración de los siguientes instrumentos de ordenamiento territorial.</p>

<p>Derivado de esto se inició con el proceso de elaboración de los instrumentos, seguido por el proceso de consulta, la cual incluyó amplia participación de los sectores que influyen en el territorio. Las fechas más relevantes sobre el proceso de elaboración se describen a continuación:</p>
    <br>
    
  `;

  const aboutLinks = [
    
    { text: 'Programa de Ordenamiento Ecológico y Territorial Regional', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/PROGRAMA%20DE%20ORDENAMIENTO%20ECOL%C3%93GICO%20TERRITORIAL%20REGIONAL%20CUENCA%20ALTA%20DE%20LA%20COSTA%20SUR.pdf' },
    { text: 'Plan Regional de Integración Urbana', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Descargas/Plan%20Regional%20de%20Integraci%C3%B3n%20Urbana%20Regi%C3%B3n%20Cuenca%20Alta%20de%20la%20Costa%20Sur..pdf' },
    { text: 'Programas Municipales de Desarrollo Urbano (Ver en Inicio)', url: '/descargas/cacs' },

  ];

  const aboutDates = [
    { label: 'Inicio de proceso de formulación', date: '31/01/2022' },
    { label: 'Inicio de consulta', date: '02/01/2023' },
    { label: 'Fin de consulta', date: '21/04/2023' },
    { label: 'Sesión de validación', date: ' 26/09/2023' },
    { label: 'Fecha Publicación', date: '13/08/2024' },
  ];
  
  const bitacoraItems = [
    {
      title: 'FASE DE FORMULACIÓN',
      icon: FileSignature,
      color: 'from-blue-500 to-cyan-500',
      content: [
        {
          subtitle: 'Acuerdos de Integración Municipal - Región Cuenca Alta de la Costa Sur',
          items: [
            { text: 'Acuerdo de integración - Casimiro Castillo', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Gestion/INICIO/Acuerdo%20de%20integraci%C3%B3n%20-%20Casimiro%20Castillo.pdf' },
            { text: 'Acuerdo de integración - Cuautitlán de Garcia Barragan', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Gestion/INICIO/Acuerdo%20de%20integraci%C3%B3n%20-%20Cuautitl%C3%A1n%20de%20Garcia%20Barragan.pdf' }
          ]
        },
        {
          subtitle: 'Actas de Aprobación',
          items: [
            { text: 'Acta de aprobación - Casimiro Castillo POETR Y PMDU', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Gestion/APROBACIoN/Acta%20de%20aprobaci%C3%B3n%20-%20Casimiro%20Castillo%20POETR%20Y%20PMDU.pdf' },
            { text: 'Acta de aprobación - Cuautitlán de Garcia Barragan POETR Y PMDU', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Gestion/APROBACIoN/Acta%20de%20aprobaci%C3%B3n%20-%20Cuautitl%C3%A1n%20de%20Garcia%20Barragan%20POETR%20Y%20PMDU.pdf' },
            { text: 'Acta de aprobación - Villa Purificación POETR Y PMDU', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Gestion/APROBACIoN/Acta%20de%20aprobaci%C3%B3n%20-%20Villa%20Purificaci%C3%B3n%20POETR%20Y%20PMDU.pdf' }
          ]
        },
        {
          subtitle: 'Convenios',
          items: [
            { text: 'Convenio Marco Estado Federación', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Convenio/ConvenioMarcoEstado_Federacion.pdf' },
            { text: 'Convenio de Coordinación Estado-Municipios Región Cuenca Alta de la Costa Sur', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Convenio/Convenio%20de%20Coordinaci%C3%B3n%20Estado-Municipios%20Regi%C3%B3n%20Cuenca%20Alta%20de%20la%20Costa%20Sur.pdf' }
          ]
        }
      ]
    },
    {
      title: 'FASE DE EXPEDICIÓN',
      icon: FileSpreadsheet,
      color: 'from-emerald-500 to-green-500',
      content: [
        {
          subtitle: 'Actas del Consejo Regional',
          items: [
            { text: 'Acta de Instalación y Primera Ordinaria', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/cacs/Consejo/Acta_Instalacion_Primera_Ordinaria.pdf' },
            { text: 'Lista de asistencia - Instalación y 1er Ordinaria', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/cacs/Consejo/Lista_Asistencia_Instalacion_y_1er_ord_CR_CACS_.pdf' },
            { text: 'Primera Ordinaria-Ampliación', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/cacs/Consejo/Acta_1er_Sesion_CACS_2023_Ampleacion.pdf' },
            { text: 'Segunda Ordinaria 2023', url: 'https://drive.google.com/file/d/10Pz9LAjZBlWdNuoCn_DNknPChHuDFcAA/view?usp=drive_link' },
            { text: 'Lista de asistencia Segunda Ordinaria 2023', url: 'https://drive.google.com/file/d/11Sd0J0TFI2qKBMqCNEgKasEMnf58Qxv5/view?usp=drive_link' }
          ]
        }
      ]
    },
    {
      title: 'FASE DE EJECUCIÓN',
      icon: Zap,
      color: 'from-amber-500 to-orange-500',
      content: [
        {
          subtitle: 'Consulta y Participación Ciudadana',
          items: [
            { text: 'Consulta Pública', url: 'https://siga.jalisco.gob.mx/ordenamientosc/cacs/Ordenamientoscacs.html' },
            { text: 'Respuestas a las Observaciones de la Consulta pública', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/cacs/Elaboracion/Respuestas_a_las_observaciones_de_la_consulta_publica_CACS.pdf' }
          ]
        },
        {
          subtitle: 'Documentos Técnicos',
          items: [
            { text: 'Programa de Ordenamiento Ecológico Territorial Regional de la Cuenca Alta de la Costa Sur', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Cacs/Elaboracion/POETR/' },
            { text: 'Publicación Periódico Oficial del Estado Región Cuenca Alta de la Costa Sur', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/cacs/Elaboracion/Publicacion_Oficial_POERT_CACS_130824.pdf' }
          ]
        }
      ]
    },
    {
      title: 'FASE DE EVALUACIÓN',
      icon: BarChart3,
      color: 'from-purple-500 to-violet-500',
      content: [
        {
          subtitle: 'Evaluaciones Programadas',
          items: []
        }
      ]
    }
  ];

  return (
    <div className="environmental-theme fade-in">
      
      <ModernBanner
        onScrollClick={handleScroll}
        regionName="Cuenca Alta de la Costa Sur"
        imageSrc="images/CONANP2.jpeg"
        stats={[
          { value: '3', label: 'Municipios', icon: MapPin },
          { value: '3,762', label: 'km²', icon: Map },
          { value: '2022', label: 'Inicio', icon: Calendar },
          { value: 'Vigente', label: 'Estado', icon: CheckCircle },
        ]}
      />
      
      <section id="introduccion" className="py-16 lg:py-24 bg-white dark:bg-gray-900 relative">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-emerald-500/20 to-teal-500/20 backdrop-blur-md border border-emerald-500/30 mb-6">
                <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse mr-2" />
                <span className="text-sm font-medium text-gray-800 dark:text-white tracking-wider">FASE </span>
                <div className="ml-2 pl-2 border-l border-gray-400/20">
                  <span className="text-xs text-gray-700 dark:text-gray-300">En Ejecución</span>
                </div>
              </div>

              <div className="prose prose-lg dark:prose-invert max-w-none">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-6">
                  Ordenamiento Región Cuenca Alta de la Costa Sur
                </h2>
                <p className="text-gray-700 dark:text-gray-300 mb-4 leading-relaxed text-justify">
                  El Gobierno del Estado de Jalisco impulsa el desarrollo sustentable en la región denominada Cuenca Alta de la Costa Sur, integrada por los municipios de Casimiro Castillo, Cuautitlán de García Barragán y Villa Purificación. Para impulsar dicho desarrollo, el día 17 de octubre del 2022, el Gobierno del Estado de Jalisco y los municipios firmaron un Convenio de Coordinación que garantiza la realización de las actividades programadas.
                </p>
                <p className="text-gray-700 dark:text-gray-300 mb-4 leading-relaxed text-justify">
                  Asimismo, se firmó con la Federación un Convenio Marco de Coordinación junto con SEMARNAT y SEDATU de fecha 27 de enero de 2020. Estos convenios establecen los fundamentos para la colaboración en el proceso de elaboración de los instrumentos de ordenamiento territorial.
                </p>
              </div>

              {/* <div className="mt-8 flex flex-wrap gap-4">
                <a
                  href="https://periodicooficial.jalisco.gob.mx/sites/periodicooficial.jalisco.gob.mx/files/09-11-2i-vi.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-6 py-3 rounded-full bg-gradient-to-r from-emerald-600 to-teal-600 text-white font-semibold shadow-lg hover:shadow-xl transition-all"
                >
                  <Download className="mr-2" size={18} />
                  Publicación en Periódico Oficial
                </a>
              </div> */}

              {/* <div className="mt-8 space-y-3">
                {aboutLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center text-emerald-700 dark:text-emerald-400 hover:text-emerald-900 dark:hover:text-emerald-300 font-medium transition duration-200"
                  >
                    <ExternalLink size={16} className="mr-2 flex-shrink-0" />
                    {link.text}
                  </a>
                ))}
              </div> */}
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="grid grid-cols-2 gap-4"
            >
              {aboutDates.map((item, index) => (
                <div key={index} className="bg-gradient-to-br from-teal-50 to-cyan-50 dark:from-teal-900/20 dark:to-cyan-900/20 rounded-xl p-6 border border-teal-200 dark:border-teal-800">
                  <div className="text-sm text-teal-600 dark:text-teal-400 font-semibold">{item.label}</div>
                  <div className="text-2xl font-bold text-gray-900 dark:text-white mt-2">{item.date}</div>
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </section>

      {/*     <section id='DocumentosE' className="min-h-screen bg-[#020617] py-12 px-4 overflow-y-auto">
     
       <DocumentRepository 
        title="POETR" 
        subtitle="CACS - Cuenca Alta de la Costa Sur" 
        mainDocs={cacsmain } 
        annexDocs={cacsAnnex }
        accentColor="emerald"
      />
    </section> */}

      <section id="documentos-especiales" className="min-h-screen bg-[#020617] py-16 px-4 overflow-y-auto">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8 text-center">
            <p className="text-emerald-400 uppercase tracking-[0.3em] text-xs font-bold mb-3">
              Documentos Especiales
            </p>
            <h2 className="text-3xl md:text-4xl font-black text-white mb-3">
              Material técnico complementario de CACS
            </h2>
            <p className="text-slate-400 max-w-2xl mx-auto">
              Accede a información especializada, cartografía y estudios de apoyo para la consulta y el análisis del ordenamiento ecológico.
            </p>
          </div>
          <DocumentRepository2
            items={cacsRepositoryDocuments}
            title="CACS"
            subtitle="Documentos y Anexos"
            onDownload={(doc) => window.open(doc.url, '_blank')}
          />
        </div>
      </section>

<Descargas dataItems={Items} />
      {/* Nueva sección: Municipios de la Región Costalegre */}
    <section className="municipalities-section py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-teal-50 to-cyan-100 dark:from-gray-900 dark:to-gray-800 min-h-screen font-sans">
      <div className="container mx-auto max-w-7xl">
        
        {/* --- Título Principal --- */}
        <h2 className="text-4xl md:text-5xl font-extrabold text-teal-800 dark:text-teal-400 text-center mb-16 relative">
          <MapPin className="inline-block mr-3 mb-1 w-10 h-10" />
          Municipios de la Región : Cuenca Alta de la Costa Sur
          <p className="text-lg font-normal text-gray-600 dark:text-gray-400 mt-2">
            Conoce los municipios y sus características clave.
          </p>
        </h2>
        
        {/* --- Grid de Tarjetas (Selector) --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {municipalities.map((municipality) => (
            <div 
              key={municipality.id}
              onClick={() => setSelectedMunicipality(municipality)}
              className={`
                municipality-card 
                rounded-2xl 
                overflow-hidden 
                shadow-xl 
                transition-all 
                duration-500 
                cursor-pointer 
                hover:shadow-2xl 
                hover:scale-[1.03]
                bg-white/90 dark:bg-gray-800/80
                backdrop-blur-sm
                border border-gray-100 dark:border-gray-700
                ${selectedMunicipality.id === municipality.id 
                  ? 'ring-4 ring-teal-500 scale-[1.03] shadow-teal-300/50 dark:shadow-teal-700/50' 
                  : 'hover:ring-2 hover:ring-teal-300'
                }
              `}
            >
              <div className={`h-28 ${municipality.color} flex flex-col items-center justify-center p-3 text-white font-bold`}>
                <img 
                  src={municipality.shield} 
                  alt={`Escudo de ${municipality.name}`} 
                  className="h-14 w-14 object-contain mb-1 drop-shadow-md"
                  onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/64x64/000000/ffffff?text=E"; }}
                />
              </div>
              <div className="p-4">
                <h3 className="text-xl font-extrabold text-center text-gray-900 dark:text-white">{municipality.name}</h3>
                <p className="text-xs text-center text-teal-600 dark:text-teal-400 mt-1 flex items-center justify-center">
                    Ver Detalles <ChevronRight className='w-3 h-3 ml-1'/>
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* --- Detalles del municipio seleccionado (Modern Panel) --- */}
        <div 
            key={selectedMunicipality.id} // Key para forzar la animación en cada selección
            className="municipality-details bg-white dark:bg-gray-800 rounded-3xl shadow-2xl p-8 md:p-12 max-w-6xl mx-auto border border-teal-200 dark:border-teal-900 animate-fade-in-up"
            style={{ '--delay': '200ms' }}
        >
          <div className="flex flex-col md:flex-row items-start gap-10">
            
            {/* Escudo y Descripción */}
            <div className="w-full md:w-1/3 flex flex-col items-center justify-center p-4 bg-gray-50 dark:bg-gray-700 rounded-xl">
              <img 
                src={selectedMunicipality.shield} 
                alt={`Escudo de ${selectedMunicipality.name}`} 
                className="h-48 w-48 object-contain shadow-lg rounded-full p-2 bg-white dark:bg-gray-900 mb-6 border-4 border-teal-300 dark:border-teal-500"
                onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/192x192/000000/ffffff?text=E"; }}
              />
              <h3 className="text-3xl font-bold mb-2 text-gray-900 dark:text-white text-center">{selectedMunicipality.name}</h3>
              <p className="text-gray-600 dark:text-gray-400 text-sm text-center italic mt-2">{selectedMunicipality.description}</p>
            </div>
            
            {/* Información Detallada (Badges) */}
            <div className="w-full md:w-2/3">
                
                <h4 className="text-2xl font-bold text-teal-700 dark:text-teal-400 mb-6 border-b border-gray-200 dark:border-gray-700 pb-2 flex items-center">
                    <Info className='w-5 h-5 mr-2'/> Datos Clave
                </h4>

                {/* Grid de Métricas */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <DetailBadge icon={Users} label="Población" value={selectedMunicipality.population} />
                    <DetailBadge icon={Map} label="Superficie" value={selectedMunicipality.area} />
                    <DetailBadge icon={Calendar} label="Municipalización" value={selectedMunicipality.foundation} />
                    <DetailBadge icon={Landmark} label="Región Administrativa" value={selectedMunicipality.administrativeRegion} />
                    <DetailBadge icon={MapPin} label="Número de UGAs" value={selectedMunicipality.NumerodeUgas} />
                    <DetailBadge icon={MountainSnow} label="Zonas de Importancia Ecológica" value={selectedMunicipality.EcologicaZona} />
                </div>
                
                {/* Atracciones (Full Width) */}
                <div className="mt-8 pt-4 border-t border-gray-200 dark:border-gray-700">
                    <h4 className="text-xl font-bold text-gray-900 dark:text-white mb-3 flex items-center">
                        <TreePineIcon className='text-blue-500 mr-2 w-5 h-5'/> Principales Atracciones
                    </h4>
                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-100 dark:border-blue-800">
                        {selectedMunicipality.attractions}
                    </p>
                </div>
              
            </div>
          </div>
        </div>
      </div>
    </section>

      {/* <Gallery imagesProp={imageList} itemsPerPage={4} /> */}
    
      <FullWidthVisorWithSidebar />
    
      <ModernBitacoraSection items={bitacoraItems} />
      <FasesSection 
        imageUrl="images/FasesOrdenamiento.png"
        altText="Fases del Ordenamiento Cuenca Alta de la Costa Sur"
      />
     
    </div>
  );
};

export default CacsPage;